import React from "react";
import PropTypes from "prop-types";
import xstream from "state-x-stream";
import {
  distinctUntilChanged,
  switchMap,
  map,
  throttleTime,
} from "rxjs/operators";
import Track from "../../models/Track";

function controller({ props$ }) {
  return {
    isHidden: props$.pipe(
      switchMap(({ track }) => track.overlayUpdated$),
      map((x) => x === null),
      distinctUntilChanged()
    ),
    overlayData: props$.pipe(
      switchMap(({ track }) => track.overlayUpdated$),
      throttleTime(500, undefined, { leading: true, trailing: true })
    ),
  };
}

function TrackOverlay({ overlayData, track, isHidden }) {
  return overlayData && !isHidden ? (
    <div className="tw-absolute tw-inset-0 tw-overflow-hidden tw-pointer-events-none">
      <track.OverlayRenderer overlayData={overlayData} track={track} />
    </div>
  ) : null;
}

TrackOverlay.propTypes = {
  overlayData: PropTypes.shape({}),
  track: PropTypes.instanceOf(Track).isRequired,
  isHidden: PropTypes.bool.isRequired,
};

TrackOverlay.defaultProps = {
  overlayData: null,
};

export default xstream(controller)(TrackOverlay);
